import {useState, useEffect} from 'react';
import ModalLayout from './ModalLayout';
import ProModalContent from './ProModalContent';
import UpgradePlanModalContent from "./UpgradePlanModalContent";
import {useCurrentWorkspaceDetailQuery} from "../../../../../hooks/queries";
import SelfCustomAvatarDashboardModal from "../SelfCustomAvatarDashboard";

const allowedPlans = ["BASIC", "PRO"];

const extractPlanFamily = (planName = "") => {
  const upper = planName.toUpperCase();
  if (upper.startsWith("PRO")) return "PRO";
  if (upper.startsWith("BASIC")) return "BASIC";
  if (upper.startsWith("FREE")) return "FREE";
  return "UNKNOWN";
};

function SelfCustomAvatarModal({closeModal}) {
  const {data: workspace} = useCurrentWorkspaceDetailQuery();
  const planName = workspace?.subscription?.plan?.name;
  const planFamily = extractPlanFamily(planName);
  const isAllowed = allowedPlans.includes(planFamily);

  const [content, setContent] = useState(null);
  const [showDashboard, setShowDashboard] = useState(false);

  useEffect(() => {
    if (isAllowed) {
      setContent(<ProModalContent openDashboard={() => setShowDashboard(true)}/>);
    } else {
      setContent(<UpgradePlanModalContent/>);
    }
  }, [isAllowed]);

  if (showDashboard) {
    return <SelfCustomAvatarDashboardModal closeModal={closeModal}/>;
  }

  return (
    <ModalLayout closeModal={closeModal}>
      {content}
    </ModalLayout>
  );
}

export default SelfCustomAvatarModal;
